import APIService from '@/services/APIService.js';

export default {
  getAll(includeExpiredRecords) {
    return APIService.apiCall().get(`/validadorLaudos/getAll/${includeExpiredRecords}`);
  },
  getById(id) {
    return APIService.apiCall().get(`/validadorLaudos/getById/${id}`);
  },
  salvar(postData, id = null) {
    return APIService.apiCall().post(`/validadorLaudos/salvar/${id}`, JSON.stringify(postData));
  },
  executar(id) {
    return APIService.apiCall().get(`/validadorLaudos/executar/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/validadorLaudos/excluir/${id}`);
  },
  duplicar(id) {
    return APIService.apiCall().get(`/validadorLaudos/duplicar/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/validadorLaudos/baixarResultado/${id}`, { responseType: 'blob', ...config });
  },
  baixarArquivoModeloBaseExterna() {
    return APIService.apiCall().get(`/validadorLaudos/baixarArquivoModeloBaseExterna`, {
      responseType: 'blob',
      timeout: 60 * 60 * 1000
    });
  },
  baixarLogsTecnicos(id, config = {}) {
    return APIService.apiCall().get(`/validadorLaudos/baixarLogsTecnicos/${id}`, { responseType: 'blob', ...config });
  },
  getTestesValidacao() {
    return APIService.apiCall().get(`/validadorLaudos/getTestesValidacao`);
  }
};
